import React from 'react';
import { Box, Card, CardContent, Stack, Typography, Avatar } from '@mui/material';

function TestimonialCard({ name, title, quote, avatarUrl }) {
    return (
        <Card
            sx={{
                minWidth: 280,
                borderRadius: 3,
                boxShadow: '0 6px 24px rgba(0,0,0,0.06)',
                scrollSnapAlign: 'start',
            }}
        >
            <CardContent>
                <Stack direction="row" alignItems="center" gap={1.5} sx={{ mb: 1 }}>
                    <Avatar src={avatarUrl} alt={name} />
                    <Box>
                        <Typography variant="subtitle1" fontWeight={700}>
                            {name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {title}
                        </Typography>
                    </Box>
                </Stack>
                <Typography variant="body2" color="text.secondary">
                    “{quote}”
                </Typography>
            </CardContent>
        </Card>
    );
}

export default function LandingTestimonialsSection() {
    return (
        <>
            <Typography variant="h4" align="center" fontWeight={800} gutterBottom>
                Was Nutzer:innen sagen
            </Typography>
            <Box sx={{ mt: 4, position: 'relative' }}>
                <Box sx={{ display: 'flex', gap: 3, overflowX: 'auto', pb: 1, scrollSnapType: 'x mandatory' }}>
                    <TestimonialCard
                        name="Laura K."
                        title="Freiberuflerin"
                        quote="Mit Schreiberlein habe ich meine Buchhaltung von 3 h auf 20 Minuten/Monat reduziert."
                    />
                    <TestimonialCard
                        name="Markus S."
                        title="Selbständiger Designer"
                        quote="Die automatische Belegverarbeitung spart so viel Zeit – endlich kein Zettelchaos mehr."
                    />
                    <TestimonialCard
                        name="Julia R."
                        title="Coach"
                        quote="Nicht überladen, sondern genau die Funktionen, die ich brauche. Sehr empfehlenswert."
                    />
                    <TestimonialCard
                        name="Deniz A."
                        title="IT-Berater"
                        quote="UStVA auf Knopfdruck – das allein ist mir den Preis wert."
                    />
                </Box>
            </Box>
        </>
    );
}
